/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetFiltersResponseDto } from '../models/GetFiltersResponseDto';
import type { GetPopularSearchesResponseDto } from '../models/GetPopularSearchesResponseDto';
import type { GetRecentSearchesResponseDto } from '../models/GetRecentSearchesResponseDto';
import type { GetSearchResponseDto } from '../models/GetSearchResponseDto';
import type { GetServicePageResponseDto } from '../models/GetServicePageResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SearchServiceDiscoveryService {
    /**
     * Search experts and services
     * Unified search across experts and service types. Supports filters, sort (relevance, rating, distance, experience), and tab-based pagination.
     * @param q Free-text search (min 2 chars)
     * @param tab Result set to paginate
     * @param serviceTypeId Filter by service type UUID
     * @param subServiceId Filter by sub-service UUID(s), comma-separated
     * @param mode Filter by session mode
     * @param sortBy Sort order
     * @param latitude Client latitude for distance
     * @param longitude Client longitude for distance
     * @param radiusKm Max radius in km (default 50)
     * @param ratingMin Minimum average rating
     * @param page Page number
     * @param pageSize Items per page (1-50)
     * @returns GetSearchResponseDto Search results (experts + services)
     * @throws ApiError
     */
    public static serviceDiscoveryControllerSearchV1(
        q?: string,
        tab?: 'experts' | 'services',
        serviceTypeId?: string,
        subServiceId?: string,
        mode?: 'online' | 'client_location' | 'expert_location',
        sortBy?: 'relevance' | 'rating' | 'distance' | 'experience',
        latitude?: number,
        longitude?: number,
        radiusKm?: number,
        ratingMin?: number,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<GetSearchResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/search',
            query: {
                'q': q,
                'tab': tab,
                'serviceTypeId': serviceTypeId,
                'subServiceId': subServiceId,
                'mode': mode,
                'sortBy': sortBy,
                'latitude': latitude,
                'longitude': longitude,
                'radiusKm': radiusKm,
                'ratingMin': ratingMin,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get popular search terms
     * Manually curated popular searches (service types + keyword "Gym").
     * @returns GetPopularSearchesResponseDto Popular searches
     * @throws ApiError
     */
    public static serviceDiscoveryControllerGetPopularSearchesV1(): CancelablePromise<GetPopularSearchesResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/search/popular',
        });
    }
    /**
     * Get recent search history
     * Client's recent search terms (requires client account).
     * @returns GetRecentSearchesResponseDto Recent searches
     * @throws ApiError
     */
    public static serviceDiscoveryControllerGetRecentSearchesV1(): CancelablePromise<GetRecentSearchesResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/search/recent',
        });
    }
    /**
     * Clear recent search history
     * Delete all recent searches for the current client.
     * @returns any Recent searches cleared successfully
     * @throws ApiError
     */
    public static serviceDiscoveryControllerClearRecentSearchesV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/search/recent',
        });
    }
    /**
     * Get filter options
     * Sort options, mode options, and service types with sub-services. Cached 5 min.
     * @returns GetFiltersResponseDto Filter options
     * @throws ApiError
     */
    public static serviceDiscoveryControllerGetFiltersV1(): CancelablePromise<GetFiltersResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/search/filters',
        });
    }
    /**
     * Get service page
     * Service type metadata + paginated expert list. Use sortBy=distance with latitude/longitude for distance sort.
     * @param serviceTypeId Service type UUID
     * @param subServiceId Sub-service UUID(s), comma-separated
     * @param mode Mode(s), comma-separated
     * @param sortBy Sort order
     * @param latitude Client latitude for distance calculation
     * @param longitude Client longitude for distance calculation
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns GetServicePageResponseDto Service page data
     * @throws ApiError
     */
    public static serviceDiscoveryControllerGetServicePageV1(
        serviceTypeId: string,
        subServiceId?: string,
        mode?: Array<'online' | 'client_location' | 'expert_location'>,
        sortBy?: 'rating' | 'distance',
        latitude?: number,
        longitude?: number,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<GetServicePageResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/search/services/{serviceTypeId}',
            path: {
                'serviceTypeId': serviceTypeId,
            },
            query: {
                'subServiceId': subServiceId,
                'mode': mode,
                'sortBy': sortBy,
                'latitude': latitude,
                'longitude': longitude,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                404: `Service type not found`,
            },
        });
    }
}
